module.exports = __webpack_public_path__ + "img/l_bar.f2369b9b.jpg";